import BaseContainer from "@base/container/BaseContainer";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";
import TweenMax from "gsap";
import Power2 from "gsap";
import {Signals} from "@/Imports";
import * as PIXI from "pixi.js";
import Config from "@/config/Config";
import gsap from "gsap";
import Facade from "../Facade";

export default class PlaneContainer extends BaseContainer {
  // region #Initialization
  constructor() {
    super();

    this.animationStates = {
      backward: "backward",
      destroy: "destroy",
      up: "up",
      down: "down",
      forward: "forward",
      hit: "hit",

      idleStars: "idleStars",
      idleStarsIn: "idleStarsIn",

      idle: "idle",
      idle_x10: "idle_x10",
      idle_x10_trans: "idle_x10_trans",
      idle_x25: "idle_x25",
      idle_x25_trans: "idle_x25_trans",
      idle_x50: "idle_x50",
      idle_x50_trans: "idle_x50_trans",
      idle_x100: "idle_x100",
      idle_x100_trans: "idle_x100_trans",
    };

    this.init();
  }

  init() {
    this.targetPosition = { x: 240, y: 10 };
    this.sourcePosition = { x: -200, y: 200 };

    this.parachutesOnScreen = 0
    this.parachutes = []
    this.parachutesPool = []

    this.addListeners();
    this.createChildren();
  }

  addListeners() {
    Signals.makeBets.add(this.onMakeBets, this)
    Signals.forceRoundStart.add(this.startForce, this)
    Signals.roundStart.add(this.start, this)
    Signals.roundEnd.add(this.onRoundEnd, this)
    Signals.playerTakeWin.add(this.onPlayerParachute, this)
  }

  createChildren() {
    this.container = new PIXI.Container();
    this.addChild(this.container);

    this.parachutesContainer = new PIXI.Container();
    this.addChild(this.parachutesContainer);
    this.parachutesContainer.position.set(this.container.x, this.container.y);

    this.plane = new SpineAnimation('witch');
    this.container.addChild(this.plane);
  }
  // endregion

  onMakeBets() {
    this.reset();

    Facade.soundManager.play('game_evil_witch_1');

    this.plane.start(['forward','backward','down','forward'], [0,0,0,0]);
    gsap.to(this.container.position, 3.5, {x: this.targetPosition.x, y: this.targetPosition.y});
  }

  reset() {
    this.container.position.set(this.sourcePosition.x, this.sourcePosition.y);
    this.clearParachutes();
  }

  startForce() {
    this.plane.start(['forward'], [true])
  }

  start() {
    Facade.soundManager.play('game_round_start_1');
    this.container.position.set(this.targetPosition.x, this.targetPosition.y);
    Signals.multiplier.add(this.updateMultiplier, this);
  }

  onRoundEnd() {
    this.plane.currentAnimation = null;
    this.clearParachutes();
    this.plane.start(['destroy'], [false])
    Signals.multiplier.remove(this.updateMultiplier, this);
  }

  updateMultiplier(value) {
    const {animationStates, plane} = this;
    let animations = ['idleStarsIn','idleStars'];

    if (value > 100) {
      animations = [animationStates.idle_x100_trans, animationStates.idle_x100]
    } else if (value > 50) {
      animations = [animationStates.idle_x50_trans, animationStates.idle_x50]
    } else if (value > 25) {
      animations = [animationStates.idle_x25_trans, animationStates.idle_x25]
    } else if (value > 10) {
      animations = [animationStates.idle_x10_trans, animationStates.idle_x10]
    }

    // Defend from repeating animation starts again from scratch
    if (plane.currentAnimation !== animations[0]) {
      this.playSackSound(animations[0])
      plane.start(animations,[false, true]);
      plane.currentAnimation = animations[0];
    }
  }

  playSackSound(animation) {
    const {animationStates} = this;
    switch (animation) {
      case animationStates.idle_x10_trans:
        Facade.soundManager.play('game_sack_1');
        break;
      case animationStates.idle_x25_trans:
      case animationStates.idle_x50_trans:
        Facade.soundManager.play('game_sack_2');
        break;
      case animationStates.idle_x100_trans:
        Facade.soundManager.play('game_sack_3');
        break;
    }
  }

  // region #Parachutes
  clearParachutes() {
    this.parachutesOnScreen = 0
    this.parachutesContainer.position.set(this.container.x, this.container.y)

    while (this.parachutes.length > 0) {
      this.poolIn(this.parachutes.pop())
    }
  }
  onPlayerParachute(data) {
    let animationName = ''

    animationName = 'ghostAnim'

    if (this.parachutesOnScreen >= Config.MAX_PARACHUTES_ON_SCREEN) {
      return
    }

    this.parachutesOnScreen++
    const p = this.poolOut()
    p.visible = true
    p.start([animationName], [false])

    this.parachutesContainer.position.set(this.container.x, this.container.y - 30)

    TweenMax.to(p, 0.5, {
      x: '-=100', ease: Power2.easeIn, delay: 0.2, onComplete: () => {
        TweenMax.to(p, 2, {
          x: '-=300', onComplete: () => {
            this.parachutesOnScreen--
          }
        })
      }
    })
    this.parachutes.push(p)
  }

  poolIn(parachute) {
    parachute.position.set(0, 0)
    parachute.stop()
    parachute.visible = false
    this.parachutesPool.push(parachute)
  }

  poolOut() {
    if (this.parachutesPool.length === 0) {
      const p = new SpineAnimation('ghost')
      this.parachutesContainer.addChild(p)
      this.parachutesPool.push(p)
    }
    return this.parachutesPool.pop()
  }
  // endregion
}
